import React from 'react';
import LinkModal from 'Components/Modals/LinkModal';
import { addQueryWithReplace } from 'Helpers/Query';
import { dispatchActionItemRefresh } from 'Hooks/useRefreshEvent';
import { ClientSimpleActionItemOverride, SimpleActionItemEditOverride } from 'Resources/SimpleActionItem';
import useUserContext from 'Context/UserContext';

function SimpleActionItemLinkModal() {
  const { isAgent } = useUserContext();
  return (
    <LinkModal
      link="simpleActionItemLink"
      editTitle="Edit Task"
      createTitle="Add Task"
      type="simpleActionItem"
      metaOverride={isAgent ? SimpleActionItemEditOverride : ClientSimpleActionItemOverride}
      onSubmit={() => {
        addQueryWithReplace({ refresh: 'action-item' });
        dispatchActionItemRefresh();
      }}
    />
  );
}

export default SimpleActionItemLinkModal;
